import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';

type CreatePurchaseInput = {
  productCode: string;
};

export const useCreatePurchase = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: CreatePurchaseInput) => {
      const response = await axios.post('/api/auth/purchase', data);
      return response.data;
    },
    onError: (error: any) => {
      console.error('Error creating purchase:', error);
    },
    onSuccess: () => {
      // Invalidate the query to refetch the user's products
      queryClient.invalidateQueries({ queryKey: ['userProducts'] });
    },
  });
};
